import simoneImage from "../assets/simone.webp";
import matteoImage from "../assets/matteo.webp";
import daniloImage from "../assets/danilo.webp";
import danieleImage from "../assets/daniele.webp";
import mirkoImage from "../assets/mirko.webp";
import riccardoImage from "../assets/riccardo.webp";

export const teamMembers = [
    {
        id: "1",
        name: "Simone Zannini",
        image: simoneImage,
        rotation: "-15",
        margin: "ml-4",
        index: ""
    },
    {
        id: "2",
        name: "Matteo Cese",
        image: matteoImage,
        rotation: "10",
        margin: "-ml-4",
        index: ""
    },
    {
        id: "3",
        name: "Danilo Avola",
        image: daniloImage,
        rotation: "-15",
        margin: "-ml-4",
        index: ""
    },
    {
        id: "4",
        name: "Daniele Pannone",
        image: danieleImage,
        rotation: "10",
        margin: "mr-4",
        index: ""
    },
    {
        id: "5",
        name: "Mirko Politi",
        image: mirkoImage,
        rotation: "-15",
        margin: "-ml-4",
        index: ""
    },
    {
        id: "6",
        name: "Riccardo Olivieri",
        image: riccardoImage,
        rotation: "10",
        margin: "-ml-4",
        index: ""
    }
];

export const teamSections = [
    {
        headings: [
            "ARTIFICIAL INTELLIGENCE",
            "& COMPUTER VISION",
            "ENGINEERS",
        ],
        members: teamMembers.slice(0, 2),
        orientation: "left",
        text: "Sviluppatori AI esperti in Deep Learning e Computer Vision, con background full-stack e focus su soluzioni reali.",
    },
    {
        headings: ["TECH SOLUTIONS", "SUPERVISORS"],
        members: teamMembers.slice(2, 4),
        orientation: "right",
        text: "Professori e ricercatori AI specializzati in Machine Learning, Deep Learning e Computer Vision, con esperienza accademica e industriale in robotica, bioinformatica e soluzioni innovative per sfide reali.",
    },
    {
        headings: [
            "EMBEDDED SYSTEMS",
            "& BUSINESS OPERATIONS",
            "SPECIALISTS",
        ],
        members: teamMembers.slice(4, 6),
        orientation: "left",
        text: "Ingegnere gestionale specializzato in dati, IA e sostenibilità, con approccio strategico e sviluppatore hardware-software orientato all'innovazione e al problem solving concreto.",
    },
];
